import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';

import { ControlledDatePicker } from '../../ControlledFields';

interface Props {
  fromFieldName?: string;
  toFieldName?: string;
}

const ValidityFormElement = ({
  fromFieldName = 'valid.from',
  toFieldName = 'valid.to'
}: Props) => {
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <ControlledDatePicker
          fullWidth
          control={control}
          name={fromFieldName}
          variant="outlined"
          label={t('validFrom')}
        />
      </Grid>
      <Grid item xs={6}>
        <ControlledDatePicker
          fullWidth
          control={control}
          name={toFieldName}
          variant="outlined"
          label={t('validTo')}
        />
      </Grid>
    </Grid>
  );
};

export default ValidityFormElement;
